import type { Session } from "@/features/auth/api/session.api";

/**
 * DESTEK OTURUMU KISITLI MI — «Kullanıcı değiştir» ile geçilmiş VE kurulum geliştirme kipinde değil
 * (30 Ekim 2026).
 *
 * Sunucu iki kipte çalışıyor (`SUPPORT_SESSION_UNRESTRICTED`, arka uç `env.ts`):
 *   - KAPALI (varsayılan, üretim): geçilen hesap bir destek oturumu. Kritik işlemler, kişisel içerik
 *     (sohbet, not, Dosyalarım, Kişisel bilgilerim) ve kişi adına yazma 403 `IMPERSONATION_FORBIDDEN`.
 *     Ekranlar bu eylemleri hiç sunmuyor ya da nedenini yazıyor.
 *   - AÇIK (geliştirme): geçilen hesap o kişinin KENDİSİ gibi çalışıyor — kullanıcının sözü: «hangi
 *     role bürünürsem onun yapabildiği her şeyi onun yerine yapabilmeliyim». Ekranlar hiçbir şeyi
 *     gizlemiyor; üstteki şerit ve denetim kaydı yine «kim, kimin adına» diyor.
 *
 * Kural tek yerde, çünkü on ekran ayrı ayrı `session.impersonation`'a bakıyordu; biri bayrağı
 * unutsaydı geliştirme kipinde sessizce kısıtlı kalırdı. «Destek oturumunda MIYIM» sorusu (şerit,
 * «Kendi hesabıma dön», sessiz yenilemenin kapalı olması) bu değil: o hâlâ `session.impersonation`.
 *
 * Alan yoksa (eski sunucu) kısıtlı sayılıyor: istemci bir kısıtı ancak sunucu söylediğinde kaldırır.
 */
export function isRestrictedSupportSession(
  session: Pick<Session, "impersonation"> & { supportSessionUnrestricted?: boolean | undefined } | null | undefined,
): boolean {
  return (session?.impersonation ?? null) !== null && session?.supportSessionUnrestricted !== true;
}
